import { softGrayColor } from 'views/report/colors.ts';
import { fontBold } from 'views/report/utils/style-consts.ts';
import { addSpace } from 'views/report/utils/utils.ts';
import { TCostItem } from 'views/report/pages/add-cost-item-afe-overview/types.ts';
import { TRow, TTableData } from 'views/report/utils/add-table/types.ts';
import i18n from 'i18next';
import translations from 'src/internationalisation/translation-map.json';
import { getCostPercentile, getNumberValue } from 'views/simulations/result-overview/result-utils';
import { PROBABILITIES } from 'views/report/utils/consts.ts';

const getHeaderCellStyle = (item: TCostItem, i: number): { [key: string]: string } => {
  return item.children && item.children.length > 0
    ? {
        fillColor: softGrayColor,
        ...(i === 1 ? { font: fontBold.fontName, fontStyle: fontBold.fontStyle } : {}),
      }
    : {};
};

export const getRows = (simulationsResult: any, costCodesIdToCodeMap: Map<string | null, string>): TTableData => {
  const headerRow = [
    { content: i18n.t(translations.code) as string },
    { content: i18n.t(translations.projects_costItems) as string },
    ...[i18n.t(translations.simulations_mean), 'P10', 'P50', 'P90'].map((label) => ({ content: label })),
  ];
  const unitRow = [...Array(2).fill({ content: '' }), ...Array(4).fill({ content: 'USD' })];
  const rows: TRow[] = [headerRow, unitRow];

  const createRow = (item: TCostItem, isChild: boolean = false): TRow => {
    return [
      {
        content: item.cost_code_id ? costCodesIdToCodeMap.get(item.cost_code_id) || '' : '',
        styles: getHeaderCellStyle(item, 0),
      },
      {
        content: `${isChild ? addSpace(4) : ''}${item.name}`,
        styles: getHeaderCellStyle(item, 1),
      },
      ...item.results.map((result, i) => ({
        content: getNumberValue(result),
        styles: getHeaderCellStyle(item, i + 2),
      })),
    ];
  };

  const traverseItems = (items: TCostItem[], isChild = false): void => {
    for (const item of items) {
      rows.push(createRow(item, isChild));
      if (item.children?.length) {
        traverseItems(item.children, true);
      }
    }
  };

  const getTotalRow = (): TRow => [
    {
      content: i18n.t(translations.total).toUpperCase(),
      styles: { font: fontBold.fontName, fontStyle: fontBold.fontStyle },
    },
    { content: '' },
    ...PROBABILITIES.map((p) => getCostPercentile(simulationsResult, p)),
  ];

  traverseItems(simulationsResult?.cost_results || []);

  return [...rows, getTotalRow()];
};
